import {
  EventsFilterCriteria,
  createEmptyCriteria,
} from '../events-filter/events-filter.model';
import { ScheduleViewName } from '../../components/duna/duna-events-schedule/events-schedule-date-range.util';

export interface DashboardEventsCalendarFilters {
  scheduleView?: ScheduleViewName;
  selectedDateIso?: string;
  eventTypes?: string[];
  organizationIds?: number[];
  educationalPathIds?: number[];
  educationalPathVersionIds?: number[];
  moduleIds?: number[];
  locationGuids?: string[];
  hideSubEvents?: boolean;
  hideFullEvents?: boolean;
  hideParticipatedEvents?: boolean;
  showGroupCalendarEvents?: boolean;
  searchText?: string;
}

function asNumberArray(value: unknown): number[] {
  if (!Array.isArray(value)) {
    if (value === '' || value == null) return [];
    const n = Number(value);
    return Number.isFinite(n) ? [n] : [];
  }
  return value
    .map((v) => Number(v))
    .filter((n) => Number.isFinite(n) && n > 0);
}

function asStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((v) => String(v)).filter(Boolean);
  }
  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

export function dashboardFiltersToCriteria(
  filters: DashboardEventsCalendarFilters | Record<string, unknown> | undefined
): EventsFilterCriteria {
  const f = (filters || {}) as DashboardEventsCalendarFilters;
  const base = createEmptyCriteria();
  return {
    ...base,
    eventType: [...(f.eventTypes || base.eventType)],
    organizationIds: asNumberArray(f.organizationIds),
    educationalPathIds: asNumberArray(f.educationalPathIds),
    educationalPathVersionIds: asNumberArray(f.educationalPathVersionIds),
    moduleIds: asNumberArray(f.moduleIds),
    locationGuids: asStringArray(f.locationGuids),
    hideSubEvents: f.hideSubEvents !== false,
    hideFullEvents: f.hideFullEvents === true,
    hideParticipatedEvents: f.hideParticipatedEvents === true,
    showGroupCalendarEvents: f.showGroupCalendarEvents === true,
    searchText: (f.searchText || '').trim(),
  };
}

export function getScheduleViewFromFilters(
  filters: Record<string, unknown> | undefined
): ScheduleViewName {
  const v = filters?.['scheduleView'];
  if (v === 'Day' || v === 'Week' || v === 'Month' || v === 'Year') {
    return v;
  }
  return 'Month';
}

export function getSelectedDateFromFilters(
  filters: Record<string, unknown> | undefined
): Date {
  const iso = filters?.['selectedDateIso'];
  if (typeof iso === 'string' && iso) {
    const d = new Date(iso);
    if (!isNaN(d.getTime())) return d;
  }
  return new Date();
}
